import request from '@/utils/request'
// 薪资查看
// 导出一个函数，用于获取工资列表
export function getListSalary(data) {
    // 发送post请求，获取工资列表
    return request({
      url: `/salary/getList`,
      method: 'post',
      data,
    })
}

export function getgetListCount(data) {
    return request({
      url: `/salary/getListCount`,
      method: 'post',
      data,
    })
}

// 薪资单条数据查询
export function getDetailSalary(data) {
    return request({
      url: `/salary/detail`,
      method: 'post',
      data,
    })
}
// 薪资 编辑
export function getUpdateSalary(data) {
    return request({
      url: `/salary/updateSalary`,
      method: 'post',
      data,
    })
}
// 角色 添加
export function addPost(data) {
    return request({
      url: `/admin/addPost`,
      method: 'post',
      data,
    })
}
// 路由 添加
export function addJurisdiction(data) {
    return request({
      url: `/admin/addJurisdiction`,
      method: 'post',
      data,
    })
}
// 路由 删除
export function deleteJurisdiction(id) {
    return request({
      url: `/admin/deleteJurisdiction/${id}`,
      method: 'DELETE',
    })
}


// WEBPACK FOOTER //
// ./src/api/salaryapi.js